import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["callIncomingOrActive", "toggleProviderMenu", "size", "location", "providerName"];
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { Button } from 'foundations-components/transitional/components/Button';
import { CommunicatorLogger } from 'calling-usage-tracker/callingTracker';
import { getButtonSource } from '../constants/changeProviderButtonLocations';
import { jsx as _jsx } from "react/jsx-runtime";
export const ChangeProviderButton = _ref => {
  let {
      callIncomingOrActive,
      toggleProviderMenu,
      size = 'extra-small',
      location,
      providerName
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const handleClick = () => {
    if (location && providerName) {
      CommunicatorLogger.log('callingExtensions_interaction', {
        action: 'change provider',
        provider_name: providerName,
        source: getButtonSource(location),
        button_location: location
      });
    }
    toggleProviderMenu(true);
  };
  return /*#__PURE__*/_jsx(Tooltip, {
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "popoverHeader.changeProviderOnActiveCall"
    }),
    disabled: !callIncomingOrActive,
    placement: "bottom left",
    children: /*#__PURE__*/_jsx(Button, Object.assign({
      onClick: handleClick,
      responsive: false,
      size: size,
      use: "transparent",
      disabled: callIncomingOrActive,
      "data-selenium-test": "change-provider-button"
    }, restProps, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "popoverHeader.changeProvider"
      })
    }))
  });
};